export const UNAUTHORIZED_ERROR_NAME = "unauthorized";
export const SESSION_EXPIRED_ERROR_NAME = "440 Login Timeout";
export const FORBIDDEN_ERROR_NAME = "forbidden";
// Not an error the server raised, but the absence of a usable answer from it
// (rate limit, 5xx, network outage). Reported to the user, never acted upon:
// nothing here says the session is over.
export const SESSION_UNAVAILABLE_ERROR_NAME = "session-unavailable";

export class UnauthorizedError extends Error {
  public constructor() {
    super();
    this.name = UNAUTHORIZED_ERROR_NAME;
  }
}

// 403 is a business decision ("you may not do this"), not a broken session: it is
// kept apart from UnauthorizedError so it can surface a message without probing or
// ending the session — refreshing or logging out would repair nothing.
export class ForbiddenError extends Error {
  public constructor() {
    super();
    this.name = FORBIDDEN_ERROR_NAME;
  }
}

export class SessionExpiredError extends Error {
  public constructor() {
    super();
    this.name = SESSION_EXPIRED_ERROR_NAME;
  }
}
